import { render, staticRenderFns } from "./AnswersTextList.vue?vue&type=template&id=a65296a4&"
import script from "./AnswersTextList.vue?vue&type=script&lang=js&"
export * from "./AnswersTextList.vue?vue&type=script&lang=js&"
import style0 from "./AnswersTextList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports